import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      entity: {
        question: '',
        answer: false,
        explanation: '',
        more_info: '',
        link: '',
      },
      source: {
        question: '',
        answer: false,
        explanation: '',
        more_info: '',
        link: '',
      },
    };
  },

  computed: {
    ...mapGetters({
      images: 'quizGame/imageList',
    }),
  },
};


// WEBPACK FOOTER //
// ./src/mixins/QuizGameMixin.js